import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AuthTokensDto, ObtainTokensRequestDto } from './auth.dto';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly rawHttp = new HttpClient(inject(HttpBackend));
  private readonly baseUrl = environment.apiUrl;

  login(payload: ObtainTokensRequestDto): Observable<AuthTokensDto> {
    return this.http.post<AuthTokensDto>(
      `${this.baseUrl}auth/obtain-tokens`,
      payload,
    );
  }

  refreshTokens(refreshToken: string): Observable<AuthTokensDto> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${refreshToken}`,
    });

    return this.rawHttp.post<AuthTokensDto>(
      `${this.baseUrl}auth/refresh-tokens`,
      {},
      { headers },
    );
  }
}
